var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TheHeader", {
        attrs: { editable: _vm.editable, toRoot: _vm.toRoot },
        on: {
          openTreeDialog: _vm.onOpenTreeDialog,
          createNewFile: _vm.onCreateNewFile
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "PlainSpec" },
        [
          _c("Doc", {
            attrs: {
              editable: _vm.editable,
              width: "100%",
              convertedHtml: _vm.convertedHtml,
              updatedDate: _vm.updatedDate,
              createdDate: _vm.createdDate,
              createdAuthorName: _vm.createdAuthorName,
              callback: _vm.callback
            },
            on: { openTreeDialog: _vm.onOpenTreeDialog }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "OverlayScreen",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowTreeDialog,
              expression: "isShowTreeDialog"
            }
          ],
          on: { close: _vm.onCloseTreeDialog }
        },
        [
          _c(
            "BaseDialog",
            {
              attrs: { overflowScroll: true },
              on: { close: _vm.onCloseTreeDialog }
            },
            [
              _c(
                "div",
                { attrs: { slot: "main" }, slot: "main" },
                [
                  _c("Tree", {
                    attrs: {
                      treeData: _vm.treeData,
                      toRoot: _vm.toRoot,
                      currentPathFromRoot: _vm.currentPathFromRoot,
                      callback: _vm.callback
                    },
                    on: { closeTreeDialog: _vm.onCloseTreeDialog }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("PortalTarget", { attrs: { name: "uploadDocumentImageDialog" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }